import React from 'react'
import './cart-item.scss'

const CartItem = ({ cartItem }) => {
    const { name, imageUrl, price, quantity } = cartItem;
    return (
        <div className='cart-item-container'>
            <img src={imageUrl} alt={`${name}`} className='image'/>
            <div className='item-details'>
                <span className='name'>{name}</span>
                <span>{quantity} x {price}</span>
            </div>
        </div>
    );
};

export default CartItem;